import React, { useCallback, useEffect, useMemo } from 'react';
import { toast } from 'react-toastify';
import i18n from 'i18next';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAgent from '../../../common/hooks/useAgent';
import missionAgent from '../../agents/missionAgent';
import MissionForm from '../form/MissionForm';
import { Container } from '../../../common/components/layout';
import { ContainerLoader } from '../../../common/components/loaders';

const MissionEdition = ({ onBackClick, onReuploadSuccess }) => {
  const { id } = useParams();
  const [fetchMission, mission, isFetchingMission] = useAgent(missionAgent.fetchMission);
  const [updateMission, updatedMission] = useAgent(missionAgent.updateMission);

  const handleSubmit = useCallback((values) => updateMission(id, values), [id, updateMission]);

  useEffect(() => {
    fetchMission(id);
  }, [fetchMission, id]);

  useEffect(() => {
    if (updatedMission) {
      toast.success(i18n.t('mission.message.updateSuccess'));
      fetchMission(id);
    }
  }, [fetchMission, id, updatedMission]);

  const formattedMission = useMemo(() => {
    if (!mission) return undefined;
    const { missionName, ...cleanedMission } = mission;
    return { ...cleanedMission, name: missionName, clientId: mission.clientId || '' };
  }, [mission]);

  if (!mission || isFetchingMission) return <ContainerLoader />;

  return (
    <Container>
      <MissionForm mission={formattedMission} onBackClick={onBackClick} onSubmit={handleSubmit} onReuploadSuccess={onReuploadSuccess} />
    </Container>
  );
};

MissionEdition.propTypes = {
  onBackClick: PropTypes.func,
  onReuploadSuccess: PropTypes.func,
};

MissionEdition.defaultProps = {
  onBackClick: undefined,
  onReuploadSuccess: undefined,
};
export default MissionEdition;
